"use client"

import { CourseWithMeta } from "../types"
import { Carousel } from "./Carousel"
import { Recording } from "./Recording"

interface Props {
    courses: Record<string, CourseWithMeta<number>>
    priority?: boolean
    title?: string
    description?: string
}

export function FreeVideos({ courses, priority, title, description }: Props) {
    return (
        <Carousel<CourseWithMeta<number>>
            href="/academy/free-videos"
            courses={courses}
            title={title ?? "Free Videos"}
            template={(slug, course, priority) => (
                <Recording key={slug} course={course} slug={slug} priority={priority} />
            )}
            description={
                description ?? "Take advantage of our free video resources to learn more about AI and ResearchWiseAI."
            }
            priority={priority}
        />
    )
}
